module.exports = __webpack_public_path__ + "static/media/midrive_icon_white.495aba8b.png";